var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    rx: 44,
    fill: "#6699ED",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"checkmark outline\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.2831 60.3287C37.9118 60.3275 37.5446 60.25 37.2045 60.1009C36.8644 59.9518 36.5586 59.7344 36.3061 59.4621L23.1436 45.46C22.6515 44.9356 22.3879 44.2373 22.4108 43.5186C22.4337 42.7999 22.7411 42.1197 23.2654 41.6277C23.7898 41.1357 24.4881 40.8721 25.2068 40.8949C25.9255 40.9178 26.6057 41.2252 27.0977 41.7496L38.2561 53.6392L61.0331 28.7225C61.2643 28.4347 61.5518 28.1971 61.8781 28.0245C62.2044 27.8518 62.5626 27.7477 62.9306 27.7185C63.2986 27.6892 63.6686 27.7356 64.0181 27.8546C64.3675 27.9736 64.689 28.1628 64.9626 28.4106C65.2363 28.6584 65.4564 28.9595 65.6094 29.2954C65.7625 29.6313 65.8452 29.995 65.8526 30.3641C65.86 30.7332 65.7919 31.0999 65.6524 31.4417C65.5129 31.7835 65.305 32.0931 65.0415 32.3517L40.2873 59.435C40.0372 59.7122 39.7324 59.9347 39.3922 60.0885C39.0519 60.2423 38.6836 60.3241 38.3102 60.3287H38.2831Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/Icon-Check.b6a90c6d450ea396c8cf0ccffc22059c.svg";
export { ForwardRef as ReactComponent };